import {UserRole, AccessType} from "../../components/AccessComponent";

import ActionList from "./terms/template/ActionList.vue"
import TermList from "./terms/template/TermList.vue"

export default [

    {
        path: "/service/action/list",
        name: "serviceList",
        component: ActionList,
        meta: {
            layout: 'base',
            menu: 'service',
            access: {roles: [UserRole.SERVICE], type: AccessType.LEVEL}
        },
    },


    {
        path: "/service/term/list",
        name: "serviceTermList",
        component: TermList,
        meta: {
            layout: 'base',
            menu: 'service',
            access: {roles: [UserRole.SERVICE], type: AccessType.LEVEL}
        },
    },
];


